import Layer from '~/models/Layer'

export const createNewLayersArray = countNewLayers => {
  const layers = []
  for (let i = 0; i < countNewLayers; i++) {
    layers.push(new Layer())
  }
  return layers
}
